import type { HeadersFunction, LoaderFunction, MetaFunction } from '@remix-run/node';
import { useLoaderData, useRouteLoaderData } from '@remix-run/react';

import StaticPage from '~/components/StaticPage';
import { staticPageClientLoader } from '~/components/StaticPage/staticPageClientLoader';
import type { RootLoaderData } from '~/root';
import getStaticPageMetaData from '~/utils/getStaticPageMetaData';
import { BASE_CACHE_TAG } from '~/utils/setCacheHeaders/index.server';
import { shouldRevalidateLoaderData } from '~/utils/shouldRevalidateLoaderData';

import { staticPageLoader } from '../../services/static_page';

export const headers: HeadersFunction = ({ loaderHeaders }) => {
  return {
    'cache-control': loaderHeaders.get('cache-control') || 'max-age=0', // no-cache
    'Cache-Tag': loaderHeaders.get('Cache-Tag') || BASE_CACHE_TAG,
  };
};

export const meta: MetaFunction<typeof staticPageLoader> = getStaticPageMetaData;
export const loader: LoaderFunction = async ({ request, context }) => {
  return staticPageLoader({
    request,
    context,
    pageRequestParams: {
      pathname: 'products',
    },
  });
};

export const clientLoader = staticPageClientLoader;

const Products = () => {
  const { page } = useLoaderData<typeof loader>();
  const { site } = useRouteLoaderData('root') as RootLoaderData;

  return <StaticPage page={page} site={site} />;
};

export const shouldRevalidate = shouldRevalidateLoaderData;

export default Products;
